import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute, provideRoutes } from '@angular/router';
import { WMS } from 'src/app/classes/device';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MustMatch } from 'src/app/data-service/must-match.validator';

@Component({
  selector: 'app-add-wms-user',
  templateUrl: './add-wms-user.component.html',
  styleUrls: ['./add-wms-user.component.scss'],
})
export class AddWmsUserComponent implements OnInit {
  private ResponseVerifiedAddWms$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateWms$: Subject<any> = new Subject();
  private ResponseVerifiedGetWmsInfo$: Subject<any> = new Subject();
  private ResponseVerifiedGetDevice$: Subject<any> = new Subject();
  wmsInfo = new WMS();
  pipe = new DatePipe('en-US')
  addWmsForm: FormGroup;
  message: string;
  DeviceList: any;
  deviceId: any;
  userId: any;
  isEditing: any;
  deviceEpcId: any;
  editUserObject: any = {};
  dataObject: any = [];
   role: any;
  roleName: string;
  deviceObject: any = {};
  addenergy_meter:any;
  energy_meter = false;
  marked = false;
  graph_inv: any;
  time: any = [{ "id": "14" }, { "id": "13" }, { "id": "12" }, { "id": "11" }, { "id": "10" }, { "id": "9" }, { "id": "8" }, { "id": "7" }, { "id": "6" }, { "id": "5" }, { "id": "4" }, { "id": "3" }, { "id": "2" }, { "id": "1" }];

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });
  }
  ngOnInit() {
    if (this.roleName == 'epc') {
      // this.getDeviceList();
    }
    if (this.roleName == 'epc' && this.isEditing == true) {
      this.getInfoByUserId();
    }
    this.addWmsForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.

      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      email: ['', [ Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]],
      password: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [ Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      sim_no: ['', [ Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [ Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      instd_capacity: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,3})?$")]],
      num_inverter: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      elec_rate: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      start_dt: ['', Validators.required],
      end_dt: ['', Validators.required],
      solar_panel: ['', [ Validators.pattern("^[a-zA-Z0-9]+$")]],
      num_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      area_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      eff_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_v: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_p: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      confirmPassword: ['', Validators.required],
      energy_meter: [''],
      graph_interval: [''],
    }, {
      validator: MustMatch('password', 'confirmPassword')
    }
    );
  }
  get f() { return this.addWmsForm.controls; }

  add_wms() {
    if(this.addWmsForm.value.energy_meter ==true || this.addWmsForm.value.energy_meter=='true'){
      this.addenergy_meter = 1;
    }else if(this.addWmsForm.value.energy_meter ==false || this.addWmsForm.value.energy_meter=='false'){
      this.addenergy_meter = 0;
    }
    if (this.addWmsForm.value.graph_interval == "") {
      this.graph_inv = "15";
    } else { this.graph_inv = this.addWmsForm.value.graph_interval; }
    var wmsInfo =
    {
      "login_id": this.addWmsForm.controls['login_id'].value,
      "name": this.addWmsForm.controls['name'].value,
      "email": this.addWmsForm.controls['email'].value,
      "password": this.addWmsForm.controls['password'].value,
      "mobile_no": this.addWmsForm.controls['mobile_no'].value,
      "sim_no": this.addWmsForm.controls['sim_no'].value,
      "address": this.addWmsForm.controls['address'].value,
      "instd_capacity": this.addWmsForm.controls['instd_capacity'].value,
      "num_inverter": this.addWmsForm.controls['num_inverter'].value,
      "elec_rate": this.addWmsForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addWmsForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addWmsForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addWmsForm.controls['solar_panel'].value,
      "num_solar_panel": this.addWmsForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addWmsForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addWmsForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addWmsForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addWmsForm.controls['t_coeff_p'].value,
      "graph_interval": this.graph_inv,
      "is_emeter":this.addenergy_meter,
    }
    this.dashbord.addWms(wmsInfo)
      .pipe(takeUntil(this.ResponseVerifiedAddWms$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/register-epc-users/wms-users']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }

  update_wms() {
    if(this.addWmsForm.value.energy_meter ==true || this.addWmsForm.value.energy_meter=='true'){
      this.addenergy_meter = 1;
    }else if(this.addWmsForm.value.energy_meter ==false || this.addWmsForm.value.energy_meter=='false'){
      this.addenergy_meter = 0;
    }
    var wmsInfo =
    {
      "id": this.userId,
      "login_id": this.addWmsForm.controls['login_id'].value,
      "name": this.addWmsForm.controls['name'].value,
      "email": this.addWmsForm.controls['email'].value,
      "mobile_no": this.addWmsForm.controls['mobile_no'].value,
      "sim_no": this.addWmsForm.controls['sim_no'].value,
      "address": this.addWmsForm.controls['address'].value,
      "instd_capacity": this.addWmsForm.controls['instd_capacity'].value,
      "num_inverter": this.addWmsForm.controls['num_inverter'].value,
      "elec_rate": this.addWmsForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addWmsForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addWmsForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addWmsForm.controls['solar_panel'].value,
      "num_solar_panel": this.addWmsForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addWmsForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addWmsForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addWmsForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addWmsForm.controls['t_coeff_p'].value,
      "is_emeter":this.addenergy_meter,
      "graph_interval": this.addWmsForm.controls['graph_interval'].value,
    }
    this.dashbord.updateWmsUser(wmsInfo).pipe(takeUntil(this.ResponseVerifiedUpdateWms$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/register-epc-users/wms-users']);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }
        }
      },
        err => {
          return console.log(err);
        })
  }

  getInfoByUserId() {
    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getInfoByWmsUserId(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedGetWmsInfo$))
      .subscribe(
        async data => {
          if (data.status) {
            this.editUserObject = {};
            this.dataObject = data.resultObject;
         /*   var editlogin_id = data.resultObject[0].login_id;
            var editName = this.dataObject[0].name;
            var editEmail = this.dataObject[0].email;
            var editMobileNo = this.dataObject[0].mobile_no;
            var editAddress = this.dataObject[0].address;
            var editInstdCapacity = this.dataObject[0].instd_capacity;
            var editNumInverter = this.dataObject[0].num_inverter;
            var editElecRate = this.dataObject[0].elec_rate;
            var editStartDate = this.dataObject[0].start_dt;
            var editEndDate = this.dataObject[0].end_dt;
            var editSolarPanel = this.dataObject[0].solar_panel;
            var editNumSolarPanel = this.dataObject[0].num_solar_panel;
            var editAreaSolarPanel = this.dataObject[0].area_solar_panel;
            var editEffSolarPanel = this.dataObject[0].eff_solar_panel;
            var editCoeffV = this.dataObject[0].t_coeff_v;
            var editCoeffT = this.dataObject[0].t_coeff_p; */
            var editEnergyMeter = data.resultObject[0].is_emeter;

            if(editEnergyMeter== 0 ){
              this.marked = false;
              this.toggleVisibility(this.marked);
            }else if(editEnergyMeter==1){
                this.marked=true;
                this.toggleVisibility(this.marked);
               }
            // set value on the from
            this.addWmsForm.get('login_id').setValue(data.resultObject[0].login_id);
            this.addWmsForm.get('name').setValue(this.dataObject[0].name);
            this.addWmsForm.get('email').setValue(this.dataObject[0].email);
            this.addWmsForm.get('mobile_no').setValue(this.dataObject[0].mobile_no);
            this.addWmsForm.get('sim_no').setValue(this.dataObject[0].sim_no);
            this.addWmsForm.get('address').setValue(this.dataObject[0].address);
            this.addWmsForm.get('instd_capacity').setValue(this.dataObject[0].instd_capacity);
            this.addWmsForm.get('num_inverter').setValue(this.dataObject[0].num_inverter);
            this.addWmsForm.get('elec_rate').setValue(this.dataObject[0].elec_rate);
            this.addWmsForm.get('start_dt').setValue(this.dataObject[0].start_dt);
            this.addWmsForm.get('end_dt').setValue(this.dataObject[0].end_dt);
            this.addWmsForm.get('solar_panel').setValue(this.dataObject[0].solar_panel);
            this.addWmsForm.get('num_solar_panel').setValue(this.dataObject[0].num_solar_panel);
            this.addWmsForm.get('area_solar_panel').setValue(this.dataObject[0].area_solar_panel);
            this.addWmsForm.get('eff_solar_panel').setValue(this.dataObject[0].eff_solar_panel);
            this.addWmsForm.get('t_coeff_v').setValue(this.dataObject[0].t_coeff_v);
            this.addWmsForm.get('t_coeff_p').setValue(this.dataObject[0].t_coeff_p);
            this.addWmsForm.get('graph_interval').setValue(this.dataObject[0].graph_interval);
            this.addWmsForm.get('password').setValue("password");
            this.addWmsForm.get('confirmPassword').setValue("password");
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  //get device list
  // getDeviceList() {

  //   this.dashbord.getAllUserDevice()
  //     .pipe(takeUntil(this.ResponseVerifiedGetDevice$))
  //     .subscribe(
  //       async data => {
  //         if (data.status) {
  //           this.DeviceList = data.resultObject;

  //         } else if (!data.status) {
  //           if (data.message == 'Unauthorised or Login Time-out') {
  //             this.toastr.info(data.message);
  //             this.router.navigate(["/login"]);

  //           } else {
  //             this.toastr.info(data.message);

  //           }
  //         }
  //       },
  //       err => {
  //         return console.error(err);
  //       }
  //     );
  // }
  //Device List Dropdown value
  // onDeviceSelect(value) {
  //   this.deviceId = Number(value);

  // }
  toggleVisibility(e){
  if(e==false){
   this.marked= false;
   this.energy_meter= false;
  }else if(e==true){
    this.marked= true;
    this.energy_meter= true;
   }
  }
  ngOnDestroy() {
    this.ResponseVerifiedUpdateWms$.next();
    this.ResponseVerifiedUpdateWms$.complete();
    this.ResponseVerifiedAddWms$.next();
    this.ResponseVerifiedAddWms$.complete();
    this.ResponseVerifiedGetWmsInfo$.next();
    this.ResponseVerifiedGetWmsInfo$.complete();
    this.ResponseVerifiedGetDevice$.next();
    this.ResponseVerifiedGetDevice$.complete();
  }
  changeTime(e) {
  }
}
